export const SizeUnits = Object.freeze(['px', 'rem', 'em', '%', 'vh', 'vw']);
export const CanvasSizeUnits = Object.freeze(['px', 'rem']);

export const BorderWidthUnits = Object.freeze(['px', 'rem', 'em']);
export const BorderStyleOptions = Object.freeze([
    { value: 'none', label: 'Отсутствует' },
    { value: 'dotted', label: 'Точки' },
    { value: 'dashed', label: 'Пунктир' },
    { value: 'solid', label: 'Сплошная' },
    { value: 'double', label: 'Двойная' },
    { value: 'groove', label: 'Выемка' },
    { value: 'ridge', label: 'Гребень ' },
    { value: 'inset', label: 'Вогнутая' },
    { value: 'outset', label: 'Выпуклая' }
]);

export const FontStyleOptions = Object.freeze([
    { label: 'Обычный', value: 'normal' },
    { label: 'Курсив', value: 'italic' },
    { label: 'Наклонный', value: 'oblique' }
]);

export const FontWeightOptions = Object.freeze([
    { label: 'Сверхтонкий (100)', value: '100' },
    { label: 'Очень тонкий (200)', value: '200' },
    { label: 'Тонкий (300)', value: '300' },
    { label: 'Нормальный (400)', value: '400' },
    { label: 'Средний (500)', value: '500' },
    { label: 'Полужирный (600)', value: '600' },
    { label: 'Жирный (700)', value: '700' },
    { label: 'Очень жирный (800)', value: '800' },
    { label: 'Сверхжирный (900)', value: '900' },
    { label: 'Тоньше (lighter)', value: 'lighter' },
    { label: 'Толще (bolder)', value: 'bolder' }
]);

export const  HorizontalAlignOptions= Object.freeze([
    { value: 'left', label: 'Слева', icon: 'mdi-format-align-left' },
    { value: 'center', label: 'По центру', icon: 'mdi-format-align-center' },
    { value: 'right', label: 'Справа', icon: 'mdi-format-align-right' }
]);

export const VerticalAlignOptions = Object.freeze([
    { value: 'top', label: 'Сверху', icon: 'mdi-format-align-top' },
    { value: 'middle', label: 'По центру', icon: 'mdi-format-align-middle' },
    { value: 'bottom', label: 'Снизу', icon: 'mdi-format-align-bottom' }
]);

export const BorderSideOptions = Object.freeze([
    { value: 'top', label: 'Сверху', icon: 'mdi-border-top-variant' },
    { value: 'right', label: 'Справа', icon: 'mdi-border-right-variant' },
    { value: 'all', label: 'Все', icon: 'mdi-border-outside' },
    { value: 'bottom', label: 'Снизу', icon: 'mdi-border-bottom-variant' },
    { value: 'left', label: 'Слева', icon: 'mdi-border-left-variant' }
]);

export const ShadowTypeOptions = Object.freeze([
    { value: '', label: 'Внешняя' },
    { value: 'inner', label: 'Внутренняя' }
]);

export const PaginationPositionOptions = Object.freeze([
    { label: 'Снизу справа', value: '' },
    { label: 'Снизу слева', value: 'b-r' },
    { label: 'Сверху справа', value: 't-r' },
    { label: 'Сверху слева', value: 't-l' }
]);
